import React, { useEffect, useState } from "react";
import { FaEnvelope, FaWhatsapp } from "react-icons/fa";
import {
  HeroSection,
  BenefitsSectionContainer,
  BenefitIcon,
  MissionSection,
  TestimonialsSection,
  TextContainer,
  ContentContainer,
  CardsContainer,
  StatsContainer,
  TestimonialsContainer,
  TestimonialEmprise,
  HeroImageContainer,
  MissionImageContainer,
  StyledImage,
  HeroTitle,
  SectionSubtitle,
  SectionTitle,
  TestimonialsTitle,
  MissionHeading,
  HeroDescription,
  TestimonialsSubtitle,
  MissionText,
  BenefitCard,
  TestimonialCard,
  CardTitle,
  CardText,
  TestimonialAuthor,
  PrimaryButton, 
  StatItem,
  FeaturesList,
  FeatureItem,
  LogosContainer,
  PartnerLogo,
  FAQWrapper,
  FAQTitle,
  FAQSubtitle,
  FAQContactInfo,
  FAQItem,
  FAQAnswer,
  StepsContainer,
  StepsContent,
  StepsTextSection,
  StepsSubtitle,
  StepsTitle,
  StepsDescription,
  StepCard,
  StepInfo,
  StepTitle,
  StepText,
  StepIconWrapper,
  StepNumber,
  StepsCardsContainer
} from "./styles";
import { STATS, ADVANTAGES, STEPSS, BENEFITSICONS, FAQ_DATA } from "./constants";
import HeaderComponent from "../../components/Header";
import FooterComponent from "../../components/Footer";
import FormsProperty from "./formsproperty";


function PropertyAdvertising() {
  const [animatedValues, setAnimatedValues] = useState(STATS.map(() => 0));
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  useEffect(() => {
    const intervals: ReturnType<typeof setInterval>[] = [];

    STATS.forEach((stat, index) => {
      let current = 0;
      const step = Math.ceil(stat.value / 100);
      const interval = setInterval(() => {
        current += step;
        if (current >= stat.value) {
          clearInterval(interval);
          current = stat.value;
        }
        setAnimatedValues((prev) => {
          const newValues = [...prev];
          newValues[index] = current;
          return newValues;
        });
      }, 30);
      intervals.push(interval);
    });

    return () => intervals.forEach(interval => clearInterval(interval));
  }, []);

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  
  const scrollToForm = () => {
    const formsPropertySection = document.getElementById('anuncie-seu-imovel-form');
    if (formsPropertySection) {
      formsPropertySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <HeaderComponent hasBorder />
      <HeroSection>
        <TextContainer>
          <HeroTitle>Aluguel mais rápido e menos complicado...</HeroTitle>
          <HeroDescription>
            Facilitando o acesso à moradia em todo o Brasil. Saiba como podemos te ajudar:
          </HeroDescription>
          <PrimaryButton onClick={scrollToForm}>ANUNCIE AGORA</PrimaryButton>
        </TextContainer>
        <HeroImageContainer>
          <StyledImage
            src="/advertise-img/hero.png"
            alt="Aluguel rápido com 7Cantos"
          />
        </HeroImageContainer>
      </HeroSection>

      <BenefitsSectionContainer>
        <div className="benefits-text-container">
          <SectionSubtitle>Vantagens de Anunciar</SectionSubtitle>
          <SectionTitle>Por que anunciar com a 7cantos?</SectionTitle>
          <SectionSubtitle>
            Somos uma plataforma imobiliária que tem como objetivo revolucionar o mercado de imóveis residenciais
          </SectionSubtitle>
        </div>

        <CardsContainer>
          {ADVANTAGES.map((adv, index) => (
            <BenefitCard key={index}>
              <BenefitIcon
                src={BENEFITSICONS[index]}
                alt={adv.title}
                loading="lazy"
              />
              <CardTitle>{adv.title}</CardTitle>
              <CardText>{adv.text}</CardText>
            </BenefitCard>
          ))}
        </CardsContainer>

        <StatsContainer>
          {STATS.map((stat, index) => (
            <StatItem key={index}>
              <span>
                {animatedValues[index]}
                {stat.isPercentage ? "%" : ""}
              </span>
              <p>{stat.label}</p>
            </StatItem>
          ))}
        </StatsContainer>
      </BenefitsSectionContainer>


      <StepsContainer>
        <StepsContent>
          <StepsTextSection>
            <StepsSubtitle>O QUE FAZEMOS</StepsSubtitle>
            <StepsTitle>Nossa Jornada de Locação</StepsTitle>
            <StepsDescription>
              Com a 7Cantos, o processo de aluguel é descomplicado e eficiente, garantindo a satisfação tanto do proprietário quanto do inquilino. Confira as nossas etapas:
            </StepsDescription>
          </StepsTextSection>

          <StepsCardsContainer>
            {STEPSS.map((step) => (
              <StepCard key={step.number}>
                <StepInfo>
                  <StepTitle>{step.title}</StepTitle>
                  <StepText>{step.description}</StepText>
                </StepInfo>
                <StepIconWrapper>
                  <StepNumber>{step.number}</StepNumber>
                  <img src={step.image} />
                </StepIconWrapper>
              </StepCard>
            ))}
          </StepsCardsContainer>
        </StepsContent>
      </StepsContainer>

      <MissionSection>
        <MissionImageContainer>
          <StyledImage
            src="/advertise-img/mission"
            alt="Missão 7Cantos"
          />
        </MissionImageContainer>
        <ContentContainer>
          <SectionSubtitle>NOSSA MISSÃO</SectionSubtitle>
          <MissionHeading>
            Queremos mudar o mundo através do seu imóvel...
          </MissionHeading>
          <MissionText>
            Nosso objetivo é tornar o acesso à moradia mais simples através de tecnologia e humanização. Acreditamos que todos merecem um lar seguro e confortável, por isso somos empenhados em tornar essa busca mais rápida e eficiente para todos:
          </MissionText>
          <FeaturesList>
            <FeatureItem>Anúncio 100% gratuito</FeatureItem>
            <FeatureItem>Sem Exclusividade</FeatureItem>
            <FeatureItem>Especialistas em Aluguel</FeatureItem>
            <FeatureItem>Segurança Garantida</FeatureItem>
          </FeaturesList>
          
          <PrimaryButton onClick={scrollToForm}>ANUNCIE GRÁTIS</PrimaryButton>
        </ContentContainer>
      </MissionSection>

      <TestimonialsSection>
        <TestimonialsTitle>
          O que nossos parceiros acham dos nossos serviços
        </TestimonialsTitle>
        <TestimonialsSubtitle>
          A 7Cantos garante confiança e segurança para os proprietários
        </TestimonialsSubtitle>
        <TestimonialsContainer>
          <TestimonialCard>
            <p>Eu tive uma experiência incrível com a 7cantos! O processo de aluguel foi fácil e rápido, e a equipe de atendimento ao cliente foi extremamente prestativa em responder todas as minhas perguntas. Eu recomendaria definitivamente a 7cantos a qualquer pessoa que esteja procurando uma propriedade para alugar.</p>
            <TestimonialAuthor>Augusto Nóbrega</TestimonialAuthor>
            <TestimonialEmprise>CEO, J.SIMÕES</TestimonialEmprise>
          </TestimonialCard>
        </TestimonialsContainer>
        <LogosContainer>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <PartnerLogo
              key={i}
              src={`/advertise-img/logo${i}`}
              alt={`Logo Parceiro ${i}`}
            />
          ))}
        </LogosContainer>
        </TestimonialsSection>

      <FormsProperty />

      <FAQWrapper>
        <FAQTitle>Ficou com alguma dúvida?</FAQTitle>
        <FAQSubtitle>
          Você também pode entrar em contato com nosso time de #superhumanos!
        </FAQSubtitle>
        <FAQContactInfo>
          <div>
            <FaEnvelope /> contato@7cantos.com
          </div>

          <div>
            <FaWhatsapp /> 4003-7654
          </div>
        </FAQContactInfo>
        {FAQ_DATA.map((item, index) => (
          <FAQItem key={index} onClick={() => toggleFaq(index)}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {item.question}
              <span style={{ fontSize: '1.5rem' }}>{openFaqIndex === index ? '−' : '+'}</span>
            </div>

            {openFaqIndex === index && (
              <FAQAnswer>
                {item.answer.map((line, i) => {
                  const isListItem = line.startsWith('   •') || line.startsWith('  -') || line.match(/^\d\./);
                  const isEmptyLine = line.trim() === '';

                  return (
                    <div
                      key={i}
                      style={{
                        marginBottom: isEmptyLine ? '12px' : '6px',
                        marginLeft: isListItem ? '24px' : '0',
                        whiteSpace: 'pre-wrap',
                        lineHeight: '1.5'
                      }}
                    >
                      {line}
                    </div>
                  );
                })}
              </FAQAnswer>
            )}
          </FAQItem>
        ))}
      </FAQWrapper>
      <FooterComponent />
    </>
  );
}

export default PropertyAdvertising;